module.exports = __webpack_public_path__ + "img/about-us.bb06747a.jpg";